import React from 'react';
import NavContainer from '../components/NavContainer/navContainer';
import FormContainer from '../components/AdminFormContainer/adminFormContainer';

function AdminLogin() {
  return (
    <>
      <NavContainer />
      <FormContainer />
    </>
  );
}

export default AdminLogin;
